import ReactDOM from 'react-dom/client';
import App from './App';
import "./assets/fonts/Pretendard.scss";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);
